import type { ComplexCollection, ComplexCollectionFilter } from 'bundles/browse-common/types/complexCollections';
import type { PageConfig_ComponentConfig_PageConfig_CollectionComponent_Fragment as PageConfigCollectionComponent } from 'bundles/page-config-common/queries/page-config/__generated__/PageConfigComponentsQuery';

export function toComplexCollection(collectionEntity: PageConfigCollectionComponent['collectionEntity']) {
  const maybeComplexCollection = collectionEntity;

  if (maybeComplexCollection?.__typename !== 'Recommendation_Collection') {
    return undefined;
  }

  if (!maybeComplexCollection.firstFilter || !maybeComplexCollection.entities) {
    return undefined;
  }

  const maybeFirst = maybeComplexCollection.firstFilter?.elements?.[0];
  if (!maybeFirst || maybeFirst.__typename !== 'Recommendation_Collection') {
    return undefined;
  }

  const maybeFirstElements =
    maybeFirst.entities?.elements.filter((rec) => rec?.__typename === 'ProductCard_ProductCard') ?? [];

  const first: ComplexCollection = {
    __typename: 'Recommendation_Collection',
    id: maybeFirst.id,
    additionalInput: maybeFirst.additionalInput,
    description: maybeFirst.description,
    recommenderConfigurationHash: maybeFirst.recommenderConfigurationHash,
    entities: {
      __typename: 'Recommendation_CollectionEntitiesPaginatedResult',
      elements: maybeFirstElements.map((elem) => {
        return {
          ...elem,
        };
      }),
    },
  };

  const filters: ComplexCollectionFilter[] = maybeComplexCollection.entities?.elements
    .map((rec) => {
      if (!rec) return null;
      if (rec.__typename !== 'Recommendation_Collection') return null;
      return {
        label: rec.filterDescription,
        context: {
          id: rec.id,
          additionalInput: rec.additionalInput,
        },
        cursor: maybeComplexCollection.entities?.pagination.cursor,
        recommenderConfigurationHash: rec.recommenderConfigurationHash,
      };
    })
    .filter(Boolean);

  return {
    first,
    filters,
  };
}
